export const parseBool = (v) => {
    if (v == null) return false;
    const s = String(v).trim().toLowerCase();
    return s === 'true' || s === '1' || s === 'yes' || s === 'y';
};

export const CLOSING_FEE_CONSUMER_ONLY = parseBool(
    process.env.REACT_APP_CLOSING_FEE_CONSUMER_ONLY
);

export const shouldShowOrderSmartFeesForBusinessMenu = () => {
    return !CLOSING_FEE_CONSUMER_ONLY;
};